import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      pergunta: 'Quem pode investir?',
      resposta: 'Qualquer pessoa física ou jurídica, brasileira ou estrangeira, pode investir nos projetos da Bravia Group. Oferecemos suporte completo para investidores internacionais, incluindo orientação sobre documentação e aspectos legais.',
    },
    {
      pergunta: 'Como funciona o acompanhamento?',
      resposta: 'Você recebe relatórios mensais com fotos, vídeos e atualizações detalhadas sobre o progresso da obra. Além disso, tem acesso a um portal exclusivo com documentos, cronograma e pode agendar visitas presenciais ao canteiro de obras.',
    },
    {
      pergunta: 'Qual o prazo médio?',
      resposta: 'O prazo médio de construção é de 9 a 11 meses, dependendo do projeto. Trabalhamos com cronogramas realistas e temos histórico de cumprimento de prazos em todos os nossos empreendimentos.',
    },
    {
      pergunta: 'Quais são os riscos?',
      resposta: 'Como todo investimento, existem riscos envolvidos, incluindo atrasos na construção, variações de mercado e custos imprevistos. Trabalhamos com margens de segurança, seguros e contratos claros para minimizar esses riscos. Recomendamos sempre consultar um assessor financeiro.',
    },
    {
      pergunta: 'Existe garantia de retorno?',
      resposta: 'Não. Os retornos estimados são baseados em análises de mercado e histórico de projetos anteriores, mas não há garantia. Cada projeto tem suas particularidades e os resultados podem variar. Toda a projeção é apresentada com transparência antes do investimento.',
    },
    {
      pergunta: 'Como é feita a distribuição dos resultados?',
      resposta: 'A distribuição é feita após a venda ou locação das unidades, conforme estabelecido em contrato. O processo é transparente e todos os investidores recebem relatórios financeiros detalhados com a prestação de contas completa.',
    },
    {
      pergunta: 'A Bravia atua em quais regiões?',
      resposta: 'Atuamos principalmente nas regiões de Tampa, Orlando, Miami, Clearwater, Sarasota e Jacksonville, na Flórida. Escolhemos áreas com alto potencial de valorização e demanda consistente no mercado imobiliário.',
    },
  ];

  return (
    <section className="bg-white py-24">
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-black mb-4">Perguntas frequentes</h2>
          <p className="text-xl text-gray-600">Tire suas dúvidas sobre investir com a Bravia Group</p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-xl overflow-hidden hover:border-gray-300 transition-colors"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="text-lg font-semibold text-black pr-8">{faq.pergunta}</span>
                <i
                  className={`ri-arrow-down-s-line text-2xl text-gray-600 transition-transform ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-8 pb-6">
                  <p className="text-gray-700 leading-relaxed">{faq.resposta}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
